const DocumentsPage = () => {
  return <div>Documents will be available in here</div>;
};
export default DocumentsPage;
